export const parseNumber = (value: string | null): number => {
    const number = Number(value);
    if (!Number.isNaN(number)) return number;
    return 0;
};
